// 실거래 데이터 수집 완료 시도 코드 (서울, 인천, 경기)
// 향후 지역 추가 시 코드만 추가
export const AVAILABLE_SIDO = new Set(['11', '28', '41']);
